import { useEffect, useState } from 'react';
import { onValue, ref } from 'firebase/database';
import { db, getEnvDbPrefix } from '@/core/firebase/config';

function countOpen(data: Record<string, { status?: string }> | null): number {
  if (!data) return 0;
  let open = 0;
  for (const suggestion of Object.values(data)) {
    if (suggestion?.status !== 'done') open++;
  }
  return open;
}

/** Open suggestions (anything not marked done) across the given offices. */
export default function useOpenSuggestionCount(officeIds: string[]): number {
  const officeKey = officeIds.join('\0');
  const [count, setCount] = useState(0);

  useEffect(() => {
    const ids = officeKey ? officeKey.split('\0') : [];
    if (ids.length === 0) {
      setCount(0);
      return;
    }

    const counts = new Map<string, number>();
    const unsubscribe = ids.map(officeId =>
      onValue(
        ref(db, getEnvDbPrefix(`office/${officeId}/suggestions`)),
        snapshot => {
          counts.set(officeId, countOpen(snapshot.val()));
          let total = 0;
          for (const value of counts.values()) total += value;
          setCount(total);
        },
        err => {
          console.error('[useOpenSuggestionCount] Firebase read failed:', err);
          counts.set(officeId, 0);
          let total = 0;
          for (const value of counts.values()) total += value;
          setCount(total);
        }
      )
    );

    return () => {
      for (const stop of unsubscribe) stop();
    };
  }, [officeKey]);

  return count;
}
